import onIntersectionObserve from '@/helpers/on_intersection_observe';

let storagesApp = null;
let storagesComponent = null;
let pendingFilterCallback = null;

$(document).on('turbolinks:before-cache', () => {
  if (storagesApp) {
    storagesApp.unmount();
    storagesApp = null;
  }
  storagesComponent = null;
  pendingFilterCallback = null;
});

$(document).on('turbolinks:load', () => {
  const node = document.querySelector('article.v4.storages_map #storages_app');
  if (!node) { return; }

  onIntersectionObserve(node, mapNode => {
    const $node = $(mapNode);
    renderStoragesApp(mapNode, {
      mapType: $node.data('map_type'),
      storages: $node.data('storages'),
      mapDataNode: $node[0],
      presetFilterOptions: $node.data('preset_filter_options'),
      isDistricts: $node.data('is_districts'),
      allBoxSizes: $node.data('all_box_sizes'),
      leadProps: $node.data('lead-props'),
      graphqlUrl: $node.data('graphql_url'),
      privacyUrl: $node.data('privacy_url'),
      privacyConsentUrl: $node.data('privacy_consent_url'),
      presetDefaultParams: $node.data('preset_default_params') || {},
      isScrollZoom: $node.data('is_scroll_zoom'),
      xlCapacity: $node.data('xl_capacity')
    }).then(({ app, component }) => {
      storagesApp = app;
      storagesComponent = component;

      if (pendingFilterCallback) {
        pendingFilterCallback(storagesComponent);
        pendingFilterCallback = null;
      }
    });
  });
});

export function applyStoragesMapFilters(queryParams) {
  if (storagesComponent) {
    storagesComponent.applyExternalFilters(queryParams);
  } else {
    pendingFilterCallback = component => component.applyExternalFilters(queryParams);
  }
}

async function renderStoragesApp(node, props) {
  const { createApp } = await import(/* webpackChunkName: "vue" */ 'vue');
  const { default: App } = await import('@/vue/storages_map-v4/index');

  const app = createApp(App, props);
  const component = app.mount(node);

  return { app, component };
}
